<template>
  <iframe
    src="https://dashboard.tawk.to/login"
    width="100%"
    height="1080px"
  ></iframe>
</template>

<script>
export default {
  name: 'tawkSupervisor',
  components: {},
  mixins: [],
  data: () => ({}),
  async mounted() {},
  methods: {},
  computed: {},
};
</script>

<style scoped lang="scss">
.rb__extended ::v-deep {
  .col-12 {
    margin-left: -24px !important;
  }
}
</style>
